import { cva, type VariantProps } from "class-variance-authority";

export const inputStyles = {
  container: cva("flex flex-col", {
    variants: {
      size: {
        desktop: "gap-1.5",
        dialog: "gap-1",
      },
    },
    defaultVariants: {
      size: "desktop",
    },
  }),
  label: cva("font-medium text-gray-900", {
    variants: {
      size: {
        desktop: "text-base",
        dialog: "text-sm",
      },
    },
    defaultVariants: {
      size: "desktop",
    },
  }),
  input: cva(
    "w-full rounded-lg font-medium text-gray-900 placeholder:font-normal placeholder:text-gray-400",
    {
      variants: {
        size: {
          desktop: "h-11 px-3.5 py-2.5 text-base placeholder:text-base",
          dialog: "h-9 px-3 py-2 text-sm placeholder:text-sm",
        },
      },
      defaultVariants: {
        size: "desktop",
      },
    },
  ),
};

export type InputStyleProps = VariantProps<typeof inputStyles.container>;
